import type { AppStartupSlice } from "../../schemas/slices/AppStartupSliceSchema.ts";
import type { GnomeSnapshotOwner } from "./gnomeSnapshotReader.ts";

export function startupForOwner(
    previous: AppStartupSlice,
    owner: GnomeSnapshotOwner | null,
): AppStartupSlice {
    if (
        previous.userId === (owner?.userId ?? null) &&
        previous.generation === (owner?.generation ?? 0)
    )
        return previous;
    return {
        userId: owner?.userId ?? null,
        generation: owner?.generation ?? 0,
        initialSurfaceReadyAt: null,
        gnomeNavigationAt: null,
        gnomePreloadMode: "off",
    };
}
